import {
  OrganizationRoleType,
  OrgUserInviteRole,
} from "../../../../autogen/bff-api";
import { useRoles } from "./useRoles";

export const useRoleName = () => {
  const roles = useRoles();
  return (role: OrganizationRoleType | OrgUserInviteRole) =>
    roles.find((userRole) => userRole.value === role)?.label ?? "Unknown role";
};
